import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { QuestionModalComponent } from './components/question-modal/question-modal.component';
import { EmptyPageComponent } from './components/empty-page/empty-page.component';
import { DoneMessageComponent } from './components/done-message/done-message.component';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { PipesModule } from './pipes/pipes.module';
import { ComingSoonComponent } from './components/coming-soon/coming-soon.component';
import { RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { TablePagesShowingComponent } from './components/table-pages-showing/table-pages-showing.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DirectivesModule } from './directives/directives.module';
import { PrimengModule } from './primeng/primeng.module';
import { DkDropdownComponent } from './components/dk-dropdown/dk-dropdown.component';
import { DkLabelComponent } from './components/dk-label/dk-label.component';
import { DkTreeSelectComponent } from './components/dk-tree-select/dk-tree-select.component';
import { DkFieldValidationErrorMessageComponent } from './components/dk-field-validation-error-message/dk-field-validation-error-message.component';
import { DkInputComponent } from './components/dk-input/dk-input.component';
import { DkInputPhonenumberComponent } from './components/dk-input-phonenumber/dk-input-phonenumber.component';
import { DkMultiselectComponent } from './components/dk-multiselect/dk-multiselect.component';
import { SelectLanguageComponent } from './components/select-language/select-language.component';

@NgModule({
  declarations: [
    QuestionModalComponent,
    EmptyPageComponent,
    DoneMessageComponent,
    ErrorMessageComponent,
    ComingSoonComponent,
    TablePagesShowingComponent,
    DkLabelComponent,
    DkDropdownComponent,
    DkTreeSelectComponent,
    DkFieldValidationErrorMessageComponent,
    DkInputComponent,
    DkInputPhonenumberComponent,
    DkMultiselectComponent,
    SelectLanguageComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    PipesModule,
    ScrollingModule,
    DirectivesModule,
    PrimengModule,
  ],
  exports: [
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    PipesModule,
    RouterModule,
    NgxPaginationModule,
    PrimengModule,

    // components
    QuestionModalComponent,
    EmptyPageComponent,
    DoneMessageComponent,
    ErrorMessageComponent,
    ComingSoonComponent,
    TablePagesShowingComponent,
    ScrollingModule,
    DirectivesModule,
    DkLabelComponent,
    DkDropdownComponent,
    DkTreeSelectComponent,
    DkFieldValidationErrorMessageComponent,
    DkInputComponent,
    DkInputPhonenumberComponent,
    DkMultiselectComponent,
    SelectLanguageComponent,
  ],
  schemas: [],
})
export class SharedModule {}
